import { MiroEmblem } from './components/miro-emblem';
import { MiroLogoDark } from './components/miro-logo-dark';
import { MiroLogoLight } from './components/miro-logo-light';
export var MiroLogo = {
  Dark: MiroLogoDark,
  Light: MiroLogoLight,
  Emblem: MiroEmblem
};